import { css } from 'linaria';
import React, { memo, StrictMode } from 'react';
import { ThemeProvider } from 'fronton-react';
import './common/styles/base.css';
import { Routes } from './pages';
import { APP_MAIN_ID } from './common/constants';

export const App = memo(() => {
  return (
    <ThemeProvider>
      <main className={app} id={APP_MAIN_ID}>
        <StrictMode>
          <Routes />
        </StrictMode>
      </main>
    </ThemeProvider>
  );
});

const app = css`
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
`;
